import { render, staticRenderFns } from "./productsSetList.vue?vue&type=template&id=4393c7ba"
import script from "./productsSetList.vue?vue&type=script&lang=js"
export * from "./productsSetList.vue?vue&type=script&lang=js"
import style0 from "./productsSetList.vue?vue&type=style&index=0&id=4393c7ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports